<app-context-menu-item
  [title]="orientation() === 'vertical' ? 'Add column above' : 'Add column to the left'"
  [close]="true"
  (execute)="addLeft()"
/>

<app-context-menu-item
  [title]="orientation() === 'vertical' ? 'Add column below' : 'Add column to the right'"
  [close]="true"
  (execute)="addRight()"
/>

<app-context-menu-item
  [title]="orientation() === 'vertical' ? 'Move column up' : 'Move to the left'"
  [close]="true"
  (execute)="moveLeft()"
/>

<app-context-menu-item
  [title]="orientation() === 'vertical' ? 'Move column down' : 'Move to the right'"
  [close]="true"
  (execute)="moveRight()"
/>

<app-context-menu-item
  [disabled]="column().uncategorized"
  title="Delete"
  [close]="true"
  note="Can't delete To Do column"
  matTooltip="Can't delete To Do column"
  [matTooltipDisabled]="!column().uncategorized"
  (execute)="delete()"
/>

<app-context-menu-divider />

<app-color-picker [inputFormControl]="columnFormGroup?.controls['color']" />
